export default __webpack_public_path__ + "static/media/marketplace-1.9f39ca65.png";